import { LocationType } from "@/services/dropdown-enums";

export const getActiveAppointmentLocations = (locations = []) =>
  locations.filter((loc) => loc.isActive !== false && loc.IsActive !== false);

export const isSinglePredefinedLocation = (locations = []) => {
  const active = getActiveAppointmentLocations(locations);
  return active.length === 1 && active[0].type !== LocationType.Custom;
};

export const shouldShowPublicLocationSelector = (locations = []) => {
  const active = getActiveAppointmentLocations(locations);
  if (active.length === 0) return false;
  if (active.length > 1) return true;
  return active[0].type === LocationType.Custom;
};

export const autoSelectPublicLocation = (locations, selectedId, onChange) => {
  const active = getActiveAppointmentLocations(locations);
  if (!active.length) return;

  if (active.length === 1) {
    const loc = active[0];
    if (loc.type === LocationType.Custom) {
      if (selectedId !== 3) {
        onChange("calendarLocationId", 3);
        onChange("customLocation", "");
      }
    } else if (selectedId !== (loc.id || loc.calendarLocationId)) {
      onChange("calendarLocationId", loc.id || loc.calendarLocationId);
      onChange("customLocation", null);
    }
  }
};

export const validatePublicLocationFields = (values = {}, locations = []) => {
  const errors = {};
  
  // Reschedule/cancellation flows: bypass location validation checks
  if (values.id) {
    return errors;
  }

  const active = getActiveAppointmentLocations(locations);

  if (!active.length || !shouldShowPublicLocationSelector(locations)) {
    return errors;
  }

  if (values.calendarLocationId === LocationType.Custom) {
    if (!values.customLocation || !String(values.customLocation).trim()) {
      errors.customLocation = "Location is required";
    }
    return errors;
  }

  if (active.length > 1) {
    const isPredefinedSelected =
      values.calendarLocationId !== LocationType.Custom &&
      values.calendarLocationId !== undefined &&
      values.calendarLocationId !== null &&
      values.calendarLocationId !== "";

    if (!isPredefinedSelected) {
      errors.customLocation = "Please select a location";
    }
  }

  return errors;
};
